// fenbendazole-dosage-calculator.ts
import Alpine from 'alpinejs';
import "../store/email-capture"
import AppAnalytics from '../analytics/AppAnalytics';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.data('fenbendazoleDosageCalculator', function() {
    return {
      weight: 0,
      weightUnit: 'kg',
      purpose: 'treatment',
      ageGroup: 'adult',

      // Outputs
      totalMg: 0,
      resultText: '',
      details: '',
      scheduleText: '',

      // Helpers
      toKg(val: number, unit: string) { return unit === 'lb' ? (val / 2.20462) : val; },
      dosageRateMgPerKg() { return 50; }, // Always 50 mg/kg for fenbendazole
      round(n: number, places = 2) { const f = Math.pow(10, places); return Math.round(n * f) / f; },

      calculate() {
        this.$store.emailCap.cancel();

        if (!this.weight || this.weight <= 0) {
          this.resultText = '';
          this.details = '';
          this.scheduleText = '';
          return;
        }

        const kg = this.toKg(this.weight, this.weightUnit);
        const mgNeeded = kg * this.dosageRateMgPerKg();
        this.totalMg = mgNeeded;

        this.resultText = `${this.round(mgNeeded, 1)} mg daily`;
        this.details = `${this.round(mgNeeded, 1)} mg total @ 50 mg/kg`;

        // Generate schedule based on purpose and age
        if (this.purpose === 'treatment') {
          this.scheduleText = 'Give daily for 3-5 consecutive days';
        } else if (this.purpose === 'prevention') {
          if (this.ageGroup === 'puppy') {
            this.scheduleText = 'Give daily for 3 consecutive days, repeat every 2-3 weeks until 3 months old';
          } else {
            this.scheduleText = 'Give daily for 3 consecutive days, repeat every 3-6 months';
          }
        }

        if (this.resultText) this.$store.emailCap.onResult();

        AppAnalytics.getPlausible()?.trackEvent('fenbendazole_dosage_result', {
          props: {
            ageGroup: this.ageGroup,
            kg,
            purpose: this.purpose,
          }
        });
      }
    };
  });
});

Alpine.start();